<template>
  <div class="BoxComunicacoes">
    <div class="BoxComunicacoes_header w-100 d-inline-flex align-items-center justify-content-between p-2"
         :class="`BoxComunicacoes_header_${propRegistro.status}`">
      <div class="d-inline-flex align-items-center">
        <b-form-checkbox
          v-if="propRegistro.status != 'CUMPRIDA' && propRegistro.status != 'CUMPRIDA_MANUAL'"
          :id="`select_${ _uid }`"
          v-model="localData.tarefa_id"
          :name="`select_${ _uid }`"
          :value="propRegistro.tarefa_id"
          @change="changeSelected" />
        <IconSvg v-if="propRegistro.status != 'CUMPRIDA' & propRegistro.status != 'CUMPRIDA_MANUAL'"
                 :icon="statusIcon[propRegistro.status]"
                 class="icon--sm m-0 p-0 mx-2 icons--white" />
        <div class="ml-2">
          {{ getNome() }}
          <br>
          <small>matrícula: </small> {{ propRegistro.registro.matricula | maskMatricula }}
        </div>
      </div>
      <button v-if="propRegistro.status != 'CUMPRIDA' && propRegistro.status != 'CUMPRIDA_MANUAL'"
              class="btn btn-outline-light"
              @click="showPendencias(`BoxPendencia${propIndex}`)">
        Pendências {{ propRegistro.errors ? `(${getQtdErrors(propRegistro.errors.length)})` : '' }}
      </button>
      <div v-if="propRegistro.status === 'CUMPRIDA_MANUAL'"
           class="mr-3">
        <b class="mr-2"> Envio Manual</b>
        <IconSvg icon="touch"
                 class="icon--sm icon-cumprida-manual" />
      </div>
    </div>
    <div class="BoxComunicacoes_body col-12 d-inline-flex justify-content-between p-2 m-0">
      <div>
        <p class="m-0 p-0 BoxComunicacoes_body_title">
          Serviço
        </p>
        <p class="m-0 p-0">
          Comunicação
        </p>
      </div>
      <div>
        <p class="m-0 p-0 BoxComunicacoes_body_title">
          Data
        </p>
        <p class="m-0 p-0 BoxComunicacoes_body_text">
          {{ propRegistro.data_inclusao | date }}
        </p>
      </div>
      <div>
        <p class="m-0 p-0 BoxComunicacoes_body_title">
          Data máxima para cumprir
        </p>
        <p class="m-0 p-0 BoxComunicacoes_body_text">
          {{ propRegistro.data_max_cumprimento | date }}
        </p>
      </div>
      <div>
        <p class="m-0 p-0 BoxComunicacoes_body_title">
          Data de cumprimento
        </p>
        <p v-if="propRegistro.data_cumprimento"
           class="m-0 p-0 BoxComunicacoes_body_text">
          {{ propRegistro.data_cumprimento | date }}
        </p>
        <p v-else
           class="m-0 p-0 BoxComunicacoes_body_text">
          Não cumprida
        </p>
      </div>
      <div>
        <p class="m-0 p-0 BoxComunicacoes_body_title">
          Data Registro
        </p>
        <p class="m-0 p-0 BoxComunicacoes_body_text">
          {{ propRegistro.registro.data_registro | date }}
        </p>
      </div>
      <div>
        <p class="m-0 p-0 BoxComunicacoes_body_title">
          Tipo de registro
        </p>
        <p class="m-0 p-0 text-capitalize BoxComunicacoes_body_text">
          {{ tipos[propRegistro.registro.tipo_registro] }}
        </p>
      </div>
      <div class="BoxComunicacoes_body_tipo">
        <p class="m-0 p-0 BoxComunicacoes_body_title">
          Tipo de Comunicação
        </p>
        <p v-if="propRegistro.acao === 'COMUNICACAO_INTRA'" 
           class="m-0 p-0 text-capitalize BoxComunicacoes_body_text">
          {{ tiposComunicacao[propRegistro.registroAnterior.tipo_comunicacao] }}
        </p>
        <p v-else 
           class="m-0 p-0 BoxComunicacoes_body_text">
          {{ getTipoComunicacao() }}
        </p>
      </div>
      <div v-if="false">
        <p class="m-0 p-0 BoxComunicacoes_body_title">
          OS
        </p>
        <p class="m-0 p-0 BoxComunicacoes_body_text">
          {{ propRegistro.registro.ordemServico.map(os => os.ordem_servico_id).join(", ") || "Sem OS" }}
        </p>
      </div>
    </div>
    <div>
      <BoxPendencias :ref="`BoxPendencia${propIndex}`"
                     :prop-errors="propRegistro.errors"
                     :prop-tarefa-id="propRegistro.tarefa_id"
                     :prop-tarefa="propRegistro"
                     @reload="reload()" />
    </div>
  </div>
</template>
<script>
  // components
  import BoxPendencias from '@/components/SofiaRei/Gerenciador/BoxPendencias.vue'

  export default {
    name: 'BoxComunicacoes',
    components: {
      BoxPendencias
    },
    props: {
      propRegistro: {type: Object, default: () => ({})},
      propSelected: {type: Boolean, default: false},
      propIndex: {type: Number, default: null}
    },
    data () {
      return {
        tipos: {
          "O": "óbito",
          "N": "nascimento",
          "C": "casamento",
          "CR": "casamento religioso",
        },
        statusIcon: {
          "A_VENCER": "calendarAlert",
          "VENCIDA": "alert",
        },
        localData: {
          tarefa_id: null
        },
        tiposComunicacao: {
          "O": "óbito",
          "N": "nascimento",
          "C": "casamento",
          "CR": "casamento religioso"
        },
        acoesComunicacao: {
          'ALTERACAO_ESTADO_CIVIL_ESCRITURA': 'Alteração de Estado Civil por Escritura Pública',
          'ALTERACAO_ESTADO_CIVIL_MANDADO': 'Alteração de Estado Civil',
        }
      }
    },
    watch: {
      propSelected () {
        if (this.propSelected) this.localData.tarefa_id = this.propRegistro.tarefa_id
        else this.localData.tarefa_id = null
      }
    },
    methods: {
      changeSelected () {
        setTimeout (() => {
          if (this.localData.tarefa_id) {
            this.$emit('addSelected', this.localData.tarefa_id)
          } else {
            this.$emit('removeSelected', this.propRegistro.tarefa_id)
          }
        }, 100)
      },
      getNome () {
        if (this.propRegistro.registro.pessoas.length === 1) return this.propRegistro.registro.pessoas[0].nome
        else return this.propRegistro.registro.pessoas.map(pessoa => pessoa.nome || pessoa.nome_antigo).join('/')
      },
      reload () {
        this.$emit('reload')
      },
      showPendencias (name) {
        this.$refs[name].showBox()
      },
      getQtdErrors (errors) {
        if (Array.isArray(errors)) {
          return errors.length
        } else {
          return '1'
        }
      },
      getTipoComunicacao () {
        if (this.propRegistro.procedimento) {
          return this.acoesComunicacao[`ALTERACAO_ESTADO_CIVIL_${this.propRegistro.procedimento.origem}`]
        } else {
          return this.acoesComunicacao[this.propRegistro.acao]
        }
      }
    }
  }
</script>
<style lang="scss">
  .BoxComunicacoes {
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.16);
    background-color: #ffffff;

    &_header {
      background: #FFFFFF;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;

      &_CUMPRIDA {
        background: #696969;
      }

      &_CUMPRIDA_MANUAL {
        background: #696969;
      }

      &_VENCIDA {
        background: #8b0000;
      }

      &_A_VENCER {
        background: #7f7e14;
      }
    }

    &_body {
      &_title {
        font-size: 15px;
        font-weight: bold;
        color: #373a3c;
        text-decoration: underline;
      }

      &_text {
        font-size: 15px;
        font-weight: normal;
        text-align: left;
        color: #373a3c;
      }

      &_tipo {
        width: 150px;
        text-align: justify;
      }
    }
  }

  .icon-cumprida-manual {
    fill: #FFFFFF;
  }
</style>
